export const getOrCreateDeviceId = () => {
    try {
        if (typeof window === "undefined") return null;

        let deviceId = localStorage.getItem("deviceId");

        if (!deviceId) {
            deviceId =
                typeof crypto !== "undefined" && crypto.randomUUID
                    ? crypto.randomUUID()
                    : Math.random().toString(36).substring(2) +
                      Date.now().toString(36);

            localStorage.setItem("deviceId", deviceId);
        }

        return deviceId;
    } catch (error) {
        console.error("DeviceId Error:", error);
        return null;
    }
};

export const getNotificationBlockedStatus = () => {
    try {
        if (typeof Notification === "undefined") return "N";

        return Notification.permission === "denied" ? "Y" : "N";
    } catch (error) {
        console.error("Notification Status Error:", error);
        return "N";
    }
};
